import { api, apiUrls } from "./api";

const tokenKey = "RiQApp";

function parseJwt(token) {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
}

class AuthenticationManager {
  _token;
  _user = null;
  _userChangeReg = [];
  userChanged;

  tokenUpdated(newToken) {
    this._token = newToken;
    if (this.userChanged) {
      this.userChanged(this);
    }
  }

  constructor() {
    let token = window.localStorage.getItem(tokenKey);
    if (token) {
      token = JSON.parse(window.localStorage.getItem(tokenKey));
    }
    this._processToken(token);
    window.addEventListener(
      "storage",
      (event) => {
        if (event.key === tokenKey) {
          let newToken = event.newValue;
          if (newToken) {
            newToken = JSON.parse(newToken);
          }

          this._processToken(newToken);
          this.tokenUpdated(newToken);
        }
      },
      false
    );

    setInterval(() => this.checkTokenExpiry(this), 10000);
  }

  checkTokenExpiry(_this) {
    if (!_this) {
      _this = this;
    }
    if (_this._user != null) {
      let expired = Date.now() >= _this._user.exp * 1000;
      if (expired) {
        api
          .post(apiUrls.RefreshToken, undefined, {
            username: _this.getUserNameFromToken(),
            refreshtoken: _this.getRefreshToken(),
          })
          .then(async (response) => {
            let newToken = await response.json();
            _this.updateToken(newToken.Token);
          })
          .catch(() => {
            _this.updateToken(null);
            window.location.href = "/login";
          });
      }
    }
    return Promise.resolve();
  }

  _processToken(token) {
    if (!token) {
      return;
    }
    this._token = token;
    this._user = null;
    try {
      this._user = parseJwt(token.accessToken);
    } catch (error) {
      console.error("exception while parsing access token : " + error);
      alert(error.message);
    }
  }

  /**
   * @returns {string}
   */
  getUserNameFromToken() {
    if (this._user) {
      return this._user["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"];
    }
    return "";
  }

  updateToken(token) {
    this._token = token;
    this._processToken(token);
    if (token) {
      window.localStorage.setItem(tokenKey, JSON.stringify(token));
    } else {
      window.localStorage.removeItem(tokenKey);
    }
  }

  getToken() {
    let result = window.localStorage.getItem(tokenKey);
    if (!result) {
      return "";
    }
    return JSON.parse(result);
  }

  getAccessToken() {
    let result = window.localStorage.getItem(tokenKey);
    if (!result) {
      return "";
    }
    return JSON.parse(result).accessToken;
  }

  getRefreshToken() {
    let result = window.localStorage.getItem(tokenKey);
    if (!result) {
      return "";
    }
    return JSON.parse(result).refreshToken;
  }

  logout() {
    this.updateToken(null);
  }
}

let authenticationManager = new AuthenticationManager();
export default authenticationManager;
